
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-serve-data/sales-pro",
      function () {
        return require("private-next-pages/self-serve-data/sales-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-serve-data/sales-pro"])
      });
    }
  